var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasksActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_tasks_active)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.45 6.10832L12.75 1.94165C12.6721 1.85533 12.577 1.78626 12.4708 1.7389C12.3646 1.69154 12.2497 1.66693 12.1334 1.66665H5.46671C5.18983 1.66335 4.91502 1.71462 4.65796 1.81753C4.4009 1.92045 4.16663 2.07299 3.96853 2.26645C3.77042 2.45991 3.61237 2.6905 3.50339 2.94504C3.39441 3.19959 3.33664 3.47311 3.33337 3.74999V16.25C3.33664 16.5269 3.39441 16.8004 3.50339 17.0549C3.61237 17.3095 3.77042 17.5401 3.96853 17.7335C4.16663 17.927 4.4009 18.0795 4.65796 18.1824C4.91502 18.2854 5.18983 18.3366 5.46671 18.3333H14.5334C14.8102 18.3366 15.0851 18.2854 15.3421 18.1824C15.5992 18.0795 15.8335 17.927 16.0316 17.7335C16.2297 17.5401 16.3877 17.3095 16.4967 17.0549C16.6057 16.8004 16.6634 16.5269 16.6667 16.25V6.66665C16.6662 6.46012 16.589 6.26115 16.45 6.10832ZM11.6667 3.33332L14.7834 6.66665H12.2834C12.1961 6.66139 12.1108 6.63879 12.0323 6.60018C11.9539 6.56157 11.8839 6.50773 11.8265 6.44179C11.7691 6.37585 11.7254 6.29914 11.698 6.21613C11.6705 6.13312 11.6599 6.04548 11.6667 5.95832V3.33332Z",
    fill: "#432DD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_tasks_active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksActive);
export default __webpack_public_path__ + "static/media/tasks-active.0719a3e5cef90f862b85e6fd591624ef.svg";
export { ForwardRef as ReactComponent };